// extracted by mini-css-extract-plugin
module.exports = {"base":"Page_base__oOQ1w","body":"Page_body__20vfY","bodyNoPadding":"Page_bodyNoPadding__2baYe","stickyHeader":"Page_stickyHeader__10nMh"};